if(!window.__v2atc){
  window.__v2atc = 1;
  window.v2CartUrl = function(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart';
  };
  window.v2CartShow = function(){
    var d = document.getElementById('CartDrawer');
    if(!d || typeof d.show !== 'function') return false;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    d.show();
    return true;
  };
  window.v2AfterAdd = function(){
    if(!window.v2CartShow()) window.location.href = window.v2CartUrl();
  };
  document.addEventListener('submit', function(e){
    var f = e.target && e.target.closest ? e.target.closest('.v2pk-form, .v2p-atc-form, .v2pa-form') : null;
    if(!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    if(btn && btn.disabled) return;
    if(btn) btn.disabled = true;
    fetch((f.getAttribute('action') || '/cart/add') + '.js', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json' } })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        if(btn) btn.disabled = false;
        window.v2AfterAdd();
      })
      .catch(function(){ if(btn) btn.disabled = false; f.submit(); });
  });

  /* Swipe op productfoto's: veeg links/rechts bladert door de galerij (stuurt de bestaande pijlknoppen aan) */
  (function(){
    var swX = 0, swY = 0, swEl = null;
    document.addEventListener('touchstart', function(e){
      var m = e.target && e.target.closest ? e.target.closest('.v2p-main') : null;
      if(!m){ swEl = null; return; }
      swEl = m;
      swX = e.touches[0].clientX;
      swY = e.touches[0].clientY;
    }, {passive: true});
    document.addEventListener('touchend', function(e){
      if(!swEl) return;
      var el = swEl; swEl = null;
      var dx = e.changedTouches[0].clientX - swX;
      var dy = e.changedTouches[0].clientY - swY;
      if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var btn = el.querySelector(dx < 0 ? '.v2g-next' : '.v2g-prev');
      if(btn) btn.click();
    }, {passive: true});
  })();
}
